import NavBar from "../../Component/NavBar/NavBar";
import {IoIosAddCircleOutline} from "react-icons/io";
import React, {useEffect, useState} from "react";
import {BiSolidUserDetail} from "react-icons/bi";
import {MdOutlineBlock, MdOutlineVerifiedUser} from "react-icons/md";
import Loading from "../../Component/Loading/Loading";
import {useNavigate} from "react-router-dom";
import apiRequests from "../../Component/axios/config/config";
import toast from "react-hot-toast";


export default function PaymentMethod() {


    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);


    const [showModalSee, setShowModalSee] = useState(false);


    function apiGetUser() {
        setLoading(true)
        apiRequests.get("/api/setting/get-setting")
            .then((response) => {
                setData(response.data.data.session);
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
            })
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        apiGetUser()
    }, []);

    return (

        <div className="p-6">
            <div className="text-3xl font-bold text-gray-800 mb-6">
                Payment Methods List
            </div>

            <NavBar item={[
                {
                    icon: <BiSolidUserDetail style={{fontSize: "22px"}}/>,
                    title: "All Payment Methods List",
                    onClick: () => {
                    }
                },
            ]}/>


            <div className="flex justify-center mt-8">
                <div className="w-full max-w-6xl md:overflow-x-auto">
                    <table className="w-full bg-white shadow-md rounded-lg overflow-hidden">
                        <thead
                            className="bg-gradient-to-r text-left from-[#1E90FF] to-[#FF6B6B] text-white">
                        <tr>
                            <th className="px-4 py-2 text-md font-medium rounded-tl-lg">Payment Method</th>
                            <th className="px-4 py-2 text-md font-medium">API Token</th>
                            <th className="px-4 py-2 text-md font-medium">Store ID</th>
                            <th className="px-4 py-2 text-md font-medium">Checkout ID</th>
                            <th className="px-4 py-2 text-md font-medium rounded-tr-lg">Action</th>
                        </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                        {
                            loading ? (
                                <tr>
                                    <td className="px-4 py-3 text-center" colSpan="5">
                                        <Loading/>
                                    </td>
                                </tr>
                            ) : data ? (
                                    <tr key={data._id}>
                                        <td className="px-4 py-3 text-md font-medium rounded-tl-lg">
                                            Moneris getway
                                        </td>
                                        <td className="px-4 py-3 text-md font-medium">
                                            {data.api_token}
                                        </td>
                                        <td className="px-4 py-3">
                                            {data.store_id}
                                        </td>
                                        <td className="px-4 py-4">
                                            {data.checkout_id}
                                        </td>
                                        <td className="px-4 py-3 text-md font-medium rounded-tr-lg">
                                            <button
                                                className="text-blue-500 hover:text-blue-700 font-medium mr-4"
                                                onClick={() => setShowModalSee(true)}
                                            >
                                                Edit
                                            </button>
                                        </td>
                                    </tr>
                                )
                                : (
                                    <tr>
                                        <td className="px-4 py-3 text-center" colSpan="5">
                                            Payment not found!
                                        </td>
                                    </tr>
                                )
                        }


                        </tbody>
                    </table>
                </div>
            </div>

            {showModalSee && < ModalEdit setShow={setShowModalSee} value={data} apiGet={apiGetUser}/>}

        </div>
    )

}


export function ModalEdit({value, apiGet, setShow}) {

    const [loading, setLoading] = useState(false);

    const [data, setData] = useState({
        store_id: value.store_id || "",
        api_token: value.api_token || "",
        checkout_id: value.checkout_id || "",
    });

    function verifyComment() {

        setLoading(true)
        apiRequests.post(`/api/transaction/set-data-session`, data)
            .then((res) => {
                apiGet()
                setShow(false)
                toast.success("changed haas successfully.")
            })
            .catch(() => {
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return (

        <div className="report-modal fixed inset-0 bg-black bg-opacity-60 md:overflow-y-auto transition-opacity">
            <div className="flex min-h-full items-end justify-center p-3 text-center">
                <div
                    className="modal relative text-black transform overflow-hidden rounded-lg bg-white p-8 w-[40%] md:w-[95%] m-auto flex flex-col">

                    <div
                        className="grid grid-cols-1 md:flex md:flex-col  auto-cols-auto gap-6 text-gray-500  justify-center">

                        <div className="mt-4">
                            <label className="block mb-2 text-left font-medium">Store ID :</label>
                            <input
                                required
                                placeholder="enter Your Store ID"
                                className="w-full p-2 border rounded-lg"
                                value={data.store_id}
                                onChange={e => setData({...data, store_id: e.target.value})}
                            />
                        </div>

                        <div className="mt-4">
                            <label className="block mb-2 text-left font-medium">API Token :</label>
                            <input
                                required
                                placeholder="enter Api token "
                                className="w-full p-2 border rounded-lg"
                                value={data.api_token}
                                onChange={e => setData({...data, api_token: e.target.value})}
                            />
                        </div>
                        <div className="mt-4">
                            <label className="block mb-2 text-left font-medium">Checkout ID :</label>
                            <input
                                required
                                placeholder="enter Checkout ID "
                                className="w-full p-2 border rounded-lg"
                                value={data.checkout_id}
                                onChange={e => setData({...data, checkout_id: e.target.value})}
                            />
                        </div>

                    </div>

                    <div className="flex justify-center items-center gap-5 mt-8">

                        <button
                            className={`px-6 py-1 border-2 text-white bg-buttonColor-shade6 border-buttonColor-shade6
                              font-bold  rounded-lg 
                             `}
                            onClick={verifyComment}
                            disabled={loading}
                        >
                            {loading ?
                                <Loading textColor={`white-0`}/>
                                :
                                "change"
                            }
                        </button>

                        <button
                            className="border-marginColor-shade6 hover:bg-marginColor-shade6 hover:text-white border-2 px-4 py-1 rounded-lg"
                            onClick={() => setShow(false)}>
                            Cancel
                        </button>

                    </div>
                </div>
            </div>
        </div>

    )
}